import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import pdfMake from "pdfmake/build/pdfmake";
import JsBarcode from "jsbarcode";
import { PDFDocument } from "pdf-lib";

import Loader from "../../../../Base/Components/Loader/Loader";
import {
  detRequisaMateriales,
  listadoEncRequisaMateriales,
} from "../../../../API/Mantenimiento/Requisas/RequisasMantenimientoRequests";
import { getDateString } from "../../../../Base/Services/Moment/Luxon";
import { formatNumberDecimal } from "../../../../Base/Services/FormatTemplate";
import { logoPPFBase64 } from "../../../../Screen/RRHH/Evaluacion/Imgs";

const ReporteRequisaMateriales = ({
  showReporte,
  setShowReporte,
  IdRequisa,
}) => {
  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [Encabezado, setEncabezado] = useState({});
  const [Detalles, setDetalles] = useState([]);
  const toast = useRef(null);

  useEffect(() => {
    if (showReporte && IdRequisa) {
      obtenerInformacion();
    }
  }, [showReporte, IdRequisa]);

  const obtenerInformacion = async () => {
    setLoading(true);

    try {
      const encabezadoData = await listadoEncRequisaMateriales(IdRequisa);
      const detallesData = await detRequisaMateriales(IdRequisa);

      setEncabezado(encabezadoData[0]);
      setDetalles(detallesData);

      await generarPDF({
        Encabezado: encabezadoData[0],
        Detalles: detallesData,
      });
    } catch (error) {
      console.error("Error al generar reporte:", error);
    }

    setLoading(false);
  };

  const generarCodigoBarras = (valor) => {
    const canvas = document.createElement("canvas");

    JsBarcode(canvas, valor || "0", {
      format: "CODE128",
      width: 2,
      height: 50,
      displayValue: true,
    });

    return canvas.toDataURL("image/png");
  };

  const obtenerCantidadPaginas = (doc) => {
    return new Promise((resolve, reject) => {
      doc.getBlob(async (blob) => {
        try {
          const arrayBuffer = await blob.arrayBuffer();
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          const totalPaginas = pdfDoc.getPageCount();
          resolve(totalPaginas);
        } catch (error) {
          reject(error);
        }
      });
    });
  };

  const generarPDF = async (datos) => {
    const { Encabezado, Detalles } = datos;

    const CodigoBarras = generarCodigoBarras(`${Encabezado?.Requisa}`);

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [20, 100, 100, 60],

      footer: (currentPage, pageCount) => {
        return {
          columns: [
            {
              text: `Página ${currentPage} de ${pageCount}`,
              alignment: "right",
              fontSize: 8,
              margin: [0, 0, 40, 0],
            },
          ],
        };
      },

      header: () => ({
        columns: [
          {
            width: "15%",
            image: logoPPFBase64?.logo,
            fit: [180, 180],
          },
          {
            width: "30%",
            stack: [
              { text: " ", margin: [0, 5] },
              {
                text: "Requisa Materiales",
                style: "headerTitle",
                alignment: "center",
              },
              {
                image: CodigoBarras,
                width: 150,
                alignment: "center",
                margin: [0, 0, 0, 5],
              },
            ],
          },
          {
            width: "30%",
            stack: [
              { text: " ", margin: [0, 5] },
              {
                text: `\nFecha:        ${getDateString(new Date(Encabezado?.Fecha))}`,
                fontSize: 10,
              },
              { text: `Área:           ${Encabezado?.Area}`, fontSize: 10 },
              { text: `Solicita:      ${Encabezado?.Agente}`, fontSize: 10 },
            ],
          },
          {
            width: "25%",
            stack: [
              { text: " ", margin: [0, 5] },
              {
                text: "Requisitos despacho requisas",
                alignment: "center",
                bold: true,
                fontSize: 10,
              },
              { text: " ", margin: [0, 5] },
              {
                text: "Firma Solicitante",
                alignment: "center",
                fontSize: 10,
                color: "#960b0b",
              },
            ],
          },
        ],
      }),

      content: [
        {
          table: {
            headerRows: 1,
            widths: ["10%", "10%", "15%", "11%", "15%", "20%", "22%", "9%"],
            body: [
              [
                {
                  text: "Estado",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Fecha",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Estante/Posición/Bodega",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Código",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Producto",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Asignación",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Máquina/Equipo",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
                {
                  text: "Cantidad",
                  style: "tableHeader",
                  border: [true, true, true, true],
                },
              ],
              ...Detalles.map((d) => [
                {
                  text: d.StatusName,
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: getDateString(new Date(d.Fecha || "")),
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: `${d.Estante || ""} / ${d.Posicion || ""} / ${d.Bandeja || ""}`,
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: d.CodigoProducto,
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: d.NombreProducto,
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: d.NombreEmpleado,
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: d.Equipo,
                  style: "tableBody",
                  border: [false, false, false, false],
                },
                {
                  text: formatNumberDecimal(d.Qty),
                  style: "tableBody",
                  alignment: "right",
                },
              ]),
            ],
          },
          layout: {
            defaultBorder: false,
          },
        },

        {
          columns: [
            {
              width: "102%",
              text: [
                {
                  text: "Comentario: ",
                  alignment: "left",
                  style: "tableHeader",
                },
                {
                  text: Encabezado?.Comentarios || "",
                  style: "tableBody",
                },
              ],
            },
            {
              width: "*",
              alignment: "right",
              table: {
                body: [
                  [
                    {
                      text: "Total: ",
                      style: "tableHeader",
                      border: [true, true, true, true],
                    },
                    {
                      text: formatNumberDecimal(
                        Detalles.reduce(
                          (sum, d) => sum + (Number(d.Qty) || 0),
                          0,
                        ),
                      ),
                      style: "tableBody",
                      alignment: "right",
                      border: [true, true, true, true],
                    },
                  ],
                ],
              },
            },
          ],
          margin: [0, 20, 0, 0],
        },

        {
          unbreakable: true,
          margin: [0, 40, 0, 0],
          table: {
            widths: ["40%", "30%", "30%"],
            body: [
              [
                {
                  stack: [
                    {
                      text: "_____________________________",
                      alignment: "center",
                    },
                    {
                      text: "Firma Solicitante",
                      alignment: "center",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [false, false, false, false],
                },
                {
                  stack: [
                    {
                      text: "_____________________________",
                      alignment: "center",
                    },
                    {
                      text: "Técnico",
                      alignment: "center",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [false, false, false, false],
                },
                {
                  stack: [
                    {
                      text: "_____________________________",
                      alignment: "center",
                    },
                    {
                      text: "Bodega",
                      alignment: "center",
                      margin: [0, 0, 0, 0],
                    },
                  ],
                  border: [false, false, false, false],
                },
              ],
            ],
          },
        },
      ],

      styles: {
        headerTitle: {
          fontSize: 11,
          bold: true,
          alignment: "center",
        },
        tableHeader: {
          fontSize: 7.5,
          alignment: "center",
          bold: true,
        },
        tableBody: {
          fontSize: 8,
          alignment: "center",
        },
      },
    };

    const pdfDoc = pdfMake.createPdf(docDefinition);

    const cantPag = await obtenerCantidadPaginas(pdfDoc);
    console.log("Total páginas:", cantPag);

    pdfDoc.getDataUrl((dataUrl) => {
      setPdfUrl(dataUrl);
      setLoading(false);
    });
  };

  return (
    <Dialog
      header="Vista Previa de Requisa"
      visible={showReporte}
      style={{ width: "66vw", height: "85vh" }}
      onHide={() => setShowReporte(false)}
    >
      <Toast ref={toast} />

      {loading ? (
        <div className="flex justify-content-center p-5">
          <Loader />
          <p className="ml-3">Generando documento...</p>
        </div>
      ) : (
        <iframe
          src={pdfUrl}
          title="Reporte Requisa"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
          }}
        />
      )}
    </Dialog>
  );
};

export default ReporteRequisaMateriales;
